import { GroupBase, SelectComponentsConfig, ValueContainerProps } from 'react-select';

import type { SelectSize } from '../interfaces';
import { sizeConfig } from '../selectConfig';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
  ownProps: ValueContainerProps<SOption, IsMulti, Group>,
  isLoading?: boolean,
  isSlim?: boolean,
  size?: SelectSize,
}

const useValueContainerStyles = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  components,
  isLoading,
  isSlim,
  size,
  ownProps,
}: IProps<SOption, IsMulti, Group>) => {
  const isDropdownIndicator = !!components?.DropdownIndicator;

  let cut = isLoading ? 21 : 0;
  cut += isDropdownIndicator ? 0 : 20;

  const width = `calc(100% - ${ cut }px)`;
  // `size` (when set) drives the line height so content fits the control's
  // min-height; otherwise fall back to the legacy isSlim/default behavior.
  const fallbackLineHeight = isSlim ? '16px' : '26px';
  const lineHeight = size ? `${ sizeConfig[size].lineHeight }px` : fallbackLineHeight;

  return {
    ...ownProps.getStyles('valueContainer', { ...ownProps }),
    padding: 0,
    width,
    lineHeight,
  };
};

export default useValueContainerStyles;
